module.exports = __webpack_public_path__ + "img/new-logo.ad38a38.svg";